import { Component, OnInit } from '@angular/core';
import { AngularTokenService } from 'angular-token';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, NgForm } from '@angular/forms';
// import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../utils/loader.service';
import Swal from 'sweetalert2';
import { Observable } from '@angular-devkit/core/node_modules/rxjs';
import { startWith, map } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { AdminService } from 'src/app/admin/admin.service';
import { FocusMonitor } from '@angular/cdk/a11y';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  signupForm: FormGroup;
  output: any;
  terms: boolean = false;
  register: boolean = true;
  // myControl = new FormControl();
  // options: string[] = [];
  // filteredOptions: Observable<string[]>;
  country_code;
  public inputType: any = 'Password';
  keyword = 'name';
  countries: any = [];
  confirm_url;

  constructor(
    private tokenService: AngularTokenService,
    private formBuilder: FormBuilder,
    public router: Router,
    private loaderService: LoaderService,
    private toastr: ToastrService,
    private authService: AuthService
  ) {

    this.authService.getInternationalCode().subscribe(
      (res: any) => {
        res.countries.forEach(element =>
          this.countries.push(element.code)
        );
      }
    );
  }



  get company_name() {
    return this.signupForm.get('company_name')
  }
  get name() {
    return this.signupForm.get('name');
  }
  get email() {
    return this.signupForm.get('login')
  }
  get phone_number() {
    return this.signupForm.get('phone_number')
  }

  get password() {
    return this.signupForm.get('password');
  }

  get phone_country_code() {
    return this.signupForm.get('phone_coutry_code');
  }

  ngOnInit() {
    this.signupForm = new FormGroup({
      'name': new FormControl("", [Validators.required, Validators.minLength(3)]),
      'company_name': new FormControl("", [Validators.required, Validators.minLength(3)]),
      'login': new FormControl("", [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      'phone_number': new FormControl("", [Validators.required, Validators.pattern(/^[0-9]\d*$/), Validators.minLength(6)]),
      'password': new FormControl("", [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/)]),
      'phone_country_code': new FormControl("+91", [Validators.required, Validators.minLength(1)])
    });


  }

  website() {
    window.open("https://res.cloudinary.com/dzz4lppcu/image/upload/v1625556392/Website_Terms_and_Conditions.pdf", "_balnk")
  }

  supplier() {
    window.open("https://res.cloudinary.com/dzz4lppcu/image/upload/v1625556392/Supplier_Terms_and_Conditions.pdf", "_blank")
  }

  privacy() {
    window.open("https://res.cloudinary.com/dzz4lppcu/image/upload/v1625556392/Supplier_Terms_and_Conditions.pdf", "_blank")
  }

  termsConditions(event) {
    if (event.checked == true) {
      this.register = false;
    }
  }

  toggleInputType(type) {
    if (type == 'Password') {
      this.inputType = 'text';
    }
    else {
      this.inputType = 'Password';
    }
  }

  countryCode(event) {

    this.country_code = event
  }

  fireMessage() {
    return this.toastr.info('Password should contain at-least one uppercase, one lowercase, one number and one special characters', 'Info');
  }

  onSubmit(form) {
    this.loaderService.display(true);
    this.signupForm.markAllAsTouched();
    if (environment.apiBaseUrl == 'https://apisystem.truventor.com/') {
      this.confirm_url = 'https://partner.truventor.com/login'
    }
    else {
      this.confirm_url = 'https://stagingpartner.truventor.com/'
    }
    if (!this.signupForm.valid) {
      this.loaderService.display(false);
      console.log(this.signupForm)
      return this.toastr.error('Please fill all the required fields', 'Error');

    }
    else {
      if (this.country_code == '') {
        return this.toastr.error('Please select one select country code', 'Error');
      }
      else {

        this.tokenService.registerAccount({
          name: form.value.name,
          company_name: form.value.company_name,
          login: form.value.login,
          phone_number: form.value.phone_number,
          password: form.value.password,
          passwordConfirmation: form.value.password,
          phone_country_code: this.country_code,
          confirm_success_url: this.confirm_url
        }).subscribe(
          res => {
            this.toastr.success("Account successfully created! Please check your email for confirmation instructions.");
            this.router.navigate(['/signup-success']);
            this.loaderService.display(false);
            localStorage.setItem('resend_mail', form.value.login)
          }, err => {
            this.loaderService.display(false);

            if (err.error.message) {
              let msg = err.error.message;
              this.toastr.error(msg, 'Error');
            } else {
              for (let i in err.error.errors) {
                if (i == "full_messages") {
                  this.toastr.error(err.error.errors[i]);
                }
              }
            }
          }
        );
      }

    }

  }




}
